const candidateKeys = [
    "planning_type",
    "planningType",
    "planningtype",
    "planning",
    "plan_type",
    "planType",
    "plan",
    "class_type",
    "classType",
    "delivery_type",
    "deliveryType",
    "delivery_mode",
    "deliveryMode",
    "format",
    "modality",
    "in_class",
    "inClass",
];

const takeHomeBooleanKeys = [
    "is_take_home",
    "isTakeHome",
    "take_home",
    "takeHome",
    "takehome",
];

const extractValue = (source: any, key: string) => {
    if (!source) return undefined;
    if (source[key] !== undefined) return source[key];
    if (source?.metadata && source.metadata[key] !== undefined) return source.metadata[key];
    return undefined;
};

export const getNormalizedPlanningType = (item: any): string | null => {
    for (const key of takeHomeBooleanKeys) {
        const raw =
            extractValue(item?.current, key) ??
            extractValue(item?.original, key);

        if (raw === undefined || raw === null) continue;

        // Accept boolean, numeric, or string truthy/falsey representations
        const isTakeHome = typeof raw === "string"
            ? raw.trim().toLowerCase() === "true"
            : Boolean(raw);

        return isTakeHome ? "take-home" : "in-class";
    }

    for (const key of candidateKeys) {
        const raw =
            extractValue(item?.current, key) ??
            extractValue(item?.original, key);

        if (raw === undefined || raw === null) continue;

        if (typeof raw === "boolean") {
            return raw ? "in-class" : "take-home";
        }

        const normalized = raw.toString().trim().toLowerCase().replace(/\s+/g, "-");
        if (normalized) return normalized;
    }

    // Default to take-home so items stay in the due bar if no planning hint is present
    return "take-home";
};

export const isTakeHomeAssignment = (item: any): boolean => {
    const planningType = getNormalizedPlanningType(item);
    if (!planningType) return false;

    return planningType.includes("take");
};
